import { formErrorAppearedDissapeared } from '@wix/bi-logger-forms-platform-uou/v2';
import { useAddressForms, useExternalData } from '@wix/form-fields';
import { useCallback } from 'react';
import { findErrorByNormalizedPath, getFieldErrors, mergeErrors, validate } from '../services';
import { runAdditionalValidation } from '../services/additional-field-validation';
export const reportErrorChanges = _ref => {
  let {
    bi,
    existingErrors,
    newErrors,
    form
  } = _ref;
  const newlyAddedErrors = newErrors.filter(newError => !existingErrors.find(error => newError.errorPath === error.errorPath && newError.errorType === error.errorType));
  const removedErrors = existingErrors.filter(error => !newErrors.find(newError => error.errorPath === newError.errorPath && error.errorType === newError.errorType));
  newlyAddedErrors.forEach(error => {
    var _form$fields, _field$view;
    const field = (_form$fields = form.fields) == null ? void 0 : _form$fields.find(_field => _field.target === error.errorPath);
    bi.report(formErrorAppearedDissapeared({
      action_type: 'appeared',
      error_name: error.errorMessage,
      field_id: field == null ? void 0 : field.id,
      field_target: field != null && field.target && 'target' in field ? field.target : undefined,
      field_name: field == null || (_field$view = field.view) == null ? void 0 : _field$view.label
    }));
  });
  removedErrors.forEach(error => {
    var _form$fields2, _field$view2;
    const field = (_form$fields2 = form.fields) == null ? void 0 : _form$fields2.find(_field => _field.target === error.errorPath);
    bi.report(formErrorAppearedDissapeared({
      action_type: 'disappeared',
      error_name: error.errorMessage,
      field_id: field == null ? void 0 : field.id,
      field_target: field != null && field.target && 'target' in field ? field.target : undefined,
      field_name: field == null || (_field$view2 = field.view) == null ? void 0 : _field$view2.label
    }));
  });
  return {
    newlyAddedErrors,
    removedErrors
  };
};
export const useValidation = _ref2 => {
  let {
    form,
    errorsRef,
    setErrors,
    validationMode
  } = _ref2;
  const {
    addressTemplates
  } = useAddressForms();
  const externalData = useExternalData();
  const validateFields = useCallback(async newValues => {
    // TODO: returns undefined when form-id missing
    const result = await validate(form, newValues, addressTemplates, validationMode);
    const _errors = (result == null ? void 0 : result.errors) || [];
    const additionalErrors = runAdditionalValidation({
      form,
      values: newValues,
      externalData
    });
    const allErrors = mergeErrors({
      errors: _errors,
      additionalErrors
    });
    setErrors(allErrors);
    return allErrors;
  }, [form, setErrors, addressTemplates, externalData, validationMode]);
  const handleFieldValidation = useCallback(async fieldsToValidate => {
    const fieldErrors = await getFieldErrors(fieldsToValidate, form, addressTemplates, externalData, validationMode);
    const otherErrors = (errorsRef.current ?? []).filter(error => {
      return !findErrorByNormalizedPath(fieldsToValidate, error.errorPath);
    });
    const allErrors = [...otherErrors, ...fieldErrors];
    setErrors(allErrors);
    return allErrors;
  }, [errorsRef, form, setErrors, addressTemplates, externalData, validationMode]);
  const validateStep = useCallback(async (stepId, newValues) => {
    var _form$steps;
    const items = (form == null || (_form$steps = form.steps) == null || (_form$steps = _form$steps.find(step => step.id === stepId)) == null || (_form$steps = _form$steps.layout) == null || (_form$steps = _form$steps.large) == null ? void 0 : _form$steps.items) || [];
    const validationErrors = await Promise.all(items.map(async item => {
      var _form$fields3;
      const field = form == null || (_form$fields3 = form.fields) == null ? void 0 : _form$fields3.find(_field => _field.id === item.fieldId);
      const fieldValidationResult = field != null && field.target ? await handleFieldValidation([{
        path: field.target,
        value: newValues[field.target]
      }]) : [];
      return fieldValidationResult;
    }));
    const validationErrorsFlatten = validationErrors.flat();
    setErrors(validationErrorsFlatten);
    return !validationErrorsFlatten.length;
  }, [form, setErrors, handleFieldValidation]);
  return {
    validateFields,
    validateStep,
    handleFieldValidation
  };
};
//# sourceMappingURL=use-validation.js.map